import { FunctionComponent } from "react";

import { ReactComponent as Logo } from "nvent-web/assets/svg/logo-horizontal.svg";
import LocalePicker from "nvent-web/scenes/Auth/components/LocalePicker";

import style from "./AnonymousHeader.module.scss";

export const AnonymousHeader: FunctionComponent = () => (
  <>
    <div className={style.placeholder} />
    <div className={style.root}>
      <div className={style.container}>
        <a href="https://www.nvent.com/raychem" target="_blank" rel="noopener noreferrer">
          <Logo width={160} />
        </a>
        <div className={style.spark} />
        <div className={style.picker}>
          <LocalePicker dark />
        </div>
      </div>
    </div>
  </>
);
